import { IDataLayer, isArrayEmpty, omniaResolve, partition } from "../../omnia"
import { IDatalayersService } from "../../types"

export type LayerLoader = ReturnType<typeof getLayerLoader>

/**
 * Implements yet another layer loader with a local cache
 * For some reason, "svc" does not seem to cache correctly - this will have to be checked at some point,
 * but no time now, and is a bit sensitive, so there
 *
 * @param svc Main service for layers
 * @returns Function accepting an array of layer ids, and a promise for fully loaded layers (including zones)
 */
export function getLayerLoader(svc: IDatalayersService) {

    // Use a map indexed by layer id as a cache
    const layerCache = new Map<number, IDataLayer>()

    return {
        get,
        clear
    }

    function clear() {
        layerCache.clear()
    }

    function get(ids: number[]) {

        // Partition the requested layers ids in "cached" (i.e., found in "layerCache")
        // and "missing" ones
        const [cached, missing] = partition(
            ids.map(id => ({ id, layer: layerCache.get(id) })),
            a => Boolean(a.layer)
        )

        const missingIds = missing.map(m => m.id)

        const found = cached.map(c => c.layer)

        // If all cached, return
        if (isArrayEmpty(missingIds)) {
            return omniaResolve(found)
        }

        // Fetch the missing layers
        return svc.getLayers(missingIds, true).then(layers => {

            // Add to cache
            for (const l of layers) {
                layerCache.set(l.DataLayerId, l)
            }

            return found.concat(layers)

        })

    }
}
